import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { Property } from "../../models/property.model";

const landmarks = [
  {
    name: "Indian Institute Of Science",
    type: "Tourist Attraction",
    distance: "6.3 Km",
  }
];

const LocationMap: React.FC<{ property: Property | null }> = ({ property }) => {
  useEffect(() => {
    if (property) {
      console.log('LocationMap component mounted or property changed:', property);
    }
  }, [property]);

  const address = property?.address || "";
  const name = property?.name || "";
  const landmarkList = property?.landmark || [];
  return (
    <>
  <div id="location-map" className="rounded-4 shadow-sm bg-white">
        <h6 className="fw-bold mb-2">
          <i className="bi bi-geo-alt-fill me-2 text-primary"></i>
          Location of {name}
        </h6>
        <p className="text-muted mb-3 text-start">
          {address}
        </p>
 
        {/* Search bar */}
        {/* <div
          className="input-group mb-4 rounded-pill overflow-hidden"
          style={{ boxShadow: "0 2px 8px 0 rgb(145, 147, 150)" }} // custom blue shadow
        >
          <span className="input-group-text bg-white border-0">
            <i className="bi bi-search"></i>
          </span>
          <input
            type="text"
            className="form-control border-0"
            placeholder="Search Area, Landmark or Transit nearby"
          />
        </div> */}

        <div className="row g-4">
          {/* Map Left */}
          <div className="col-md-8">
            <div className="rounded-4 shadow-sm bg-white p-0">
              <div className="ratio ratio-21x9" style={{ borderRadius: "12px" }}>
                <iframe
                  title="Google Map"
                  src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyBFHkJCSUyW7FqPZAHPD0NpNdPWMmDcIa8&q=${encodeURIComponent(address)}`}
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>

          {/* Sidebar Right */}
          <div className="col-md-4">
            <div className="rounded-4 bg-white ">
              {/* Landmarks */}
              <div className="mb-3">
                <div className="d-flex justify-content-between align-items-center">
                  <h6 className="fw-bold mb-0">
                    <i className="bi bi-geo-alt me-2"></i>Landmarks
                  </h6>
                  <i className="bi bi-chevron-up text-muted"></i>
                </div>
                <hr className="my-2" />
                <ul className="list-unstyled">
                  {landmarks.map((item, idx) => (
                    <li
                      key={idx}
                      className="d-flex justify-content-between align-items-start mb-3"
                    >
                      <div className="text-start">
                        <span className="fw-semibold">{landmarkList}</span>
                        <div>
                          <span className="badge bg-light text-dark border fw-normal">
                            {item.type}
                          </span>
                        </div>
                      </div>
                      <span className="text-primary">{item.distance}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Transit */}
              <div className="mb-3">
                <div className="d-flex justify-content-between align-items-center">
                  <h6 className="fw-bold mb-0">
                    <i className="bi bi-train-front me-2"></i>Transit
                  </h6>
                  <i className="bi bi-chevron-down text-muted"></i>
                </div>
              </div>

              {/* Others */}
              <div>
                <div className="d-flex justify-content-between align-items-center">
                  <h6 className="fw-bold mb-0">
                    <i className="bi bi-three-dots me-2"></i>Others
                  </h6>
                  <i className="bi bi-chevron-down text-muted"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LocationMap;
